/* SPS V5 : recherche dans les LIENS de collections. Jamais dans les produits. */
(function(){
  'use strict';
  function normalize(value){
    var text = String(value || '').toLocaleLowerCase('fr');
    return text.normalize ? text.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : text;
  }
  function init(){
    document.querySelectorAll('.sps-bitz-menu > .collapsible.level1').forEach(function(toggle){
      if (toggle.dataset.spsKeyboardReady) return;
      toggle.dataset.spsKeyboardReady = 'true';
      toggle.addEventListener('keydown',function(event){
        if (event.key !== 'Enter' && event.key !== ' ') return;
        if (window.matchMedia('(min-width:1024px)').matches) return;
        event.preventDefault();
        toggle.click();
      });
    });
    document.querySelectorAll('[data-sps-bitz-filter]').forEach(function(input){
      if (input.dataset.spsReady) return;
      var type = input.getAttribute('data-sps-bitz-filter');
      var list = document.querySelector('[data-sps-bitz-list="'+type+'"]');
      if (!list) return;
      input.dataset.spsReady = 'true';
      var elements = Array.from(list.querySelectorAll('a[href]'));
      var empty = list.nextElementSibling;
      function filter(){
        var query = normalize(input.value.trim());
        var visible = 0;
        elements.forEach(function(link){
          var match = normalize(link.textContent).indexOf(query) !== -1;
          link.hidden = !match;
          if (match) visible++;
        });
        if (empty && empty.classList.contains('sps-bitz-filter-empty')) empty.hidden = visible > 0;
      }
      input.addEventListener('input', filter);
      filter();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init);
  else init();
  document.addEventListener('shopify:section:load',init);
})();
